import { Messages } from '../../../../codegen/Localize';
import { IBackgroundJobInfo } from '../../../../ts/resources/BackgroundJobs';
import { ICancelBackgroundJobAction } from '../../../../ts/ServerApi/types/actionNames';
import { cancelBackgroundJobAction } from '../../../actions/spaces/CancelBackgroundJobAction';
import { IEntityAction } from './IEntityAction';

export const CancelBackgroundJobAction: IEntityAction<IBackgroundJobInfo, ICancelBackgroundJobAction> = {
  name: 'cancelBackgroundJob',
  translateName: Messages.cancel,
  isVisible: () => true, // probably need to do something here
  isClickable: (availableActions: ICancelBackgroundJobAction) => !!(availableActions && availableActions.cancelBackgroundJob),
  createReduxAction: (targetItems: IBackgroundJobInfo[]) => cancelBackgroundJobAction(targetItems[0])
};
